import application from 'application/application';

// import moment from 'moment';

const controller = 'DefaultMovementsSidebarController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$http',
	'$state',
	'$stateParams',
	'API',
	'helper',
	'$timeout',
	'$interval',
	'authentication',
	'permissions',
	'$location',
	(
		$scope,
		$rootScope,
		$http,
		$state,
		$stateParams,
		API,
		helper,
		$timeout,
		$interval,
		authentication,
		permissions,
		$location
	) => {
		if (
			!permissions.has('recordPublications') &&
			!permissions.has('createMovements')
		)
			$scope.showVideo = true;
		$rootScope.handleOnClickPub = false;
		$rootScope.handleOnClickProcess = false;

		const itemExist = (object, id) => {
			var r = false;

			object.map(item => {
				if (item.id == id) r = true;
			});

			return r;
		};

		const idProdutoAdvise = parseInt(
			authentication.getUserData('idProdutoAdvise')
		);

		$scope.existsKeywords = false;
		$scope.existsProcess = false;
		$scope.processLoading = false;

		$scope.collapseShow = true;

		$scope.printing = false;

		$rootScope.printingProc = 'standard';

		$scope.userClient = authentication.getUserData('nome');

		$scope.groupUserSelected =
			localStorage.getItem('__groupSelected__') || 'false';

		if ($scope.groupUserSelected == null || $scope.groupUserSelected == 'false')
			$scope.groupUserSelected = false;

		$scope.groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

		$scope.hasNextPage = true;

		/** Instância de armazenamento de resposta. */
		$rootScope.keyWordsMovements = helper.responseStore().setItemsPerPage(9999);

		/** Instância de armazenamento de resposta. */
		$rootScope.processMovements = helper
			.responseStore()
			.setCurrentPage(1)
			.setItemsPerPage(10);

		$scope.stateParams = helper.cloneSimpleObject($stateParams);

		/**
		 * Recupera palavras chave.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.keyWordsMovements = helper.responseStore();
		 *
		 * // Recupera as aplicações.
		 * $scope.recordKeyWordsMovements($scope.keyWordsMovements);
		 */
		$rootScope.recordKeyWordsMovements = async (
			responseStore,
			isSearchFromModal = false
		) => {
			$scope.currentPageKeywords = 1;

			let requestParams = {
				campos: '*',
				registrosPorPagina: isSearchFromModal ? 99999 : 10,
				paginaAtual: $scope.currentPageKeywords,
				nome: $scope.keywordFilters && $scope.keywordFilters.keyword,
				idTipoPasta: '-2',
				ativo: true,
				idGrupoUsuarios:
					$scope.groupUserSelected && $scope.groupData
						? $scope.groupData.idGrupo
						: null
			};

			await $http({
				...helper.http(API.briefcase, 'GET'),
				params: requestParams,
				noCancelOnRouteChange: true
			}).then(response => {
				$scope.publicationPaste = response.data.itens;

				let keywords = response.data.itens;
				let idsKeywords = [];

				$scope.existsKeywords = true;

				$.extend($rootScope.pagination, {
					totalItens: response.data.itens.quantidadeTotal
				});

				idsKeywords.push(response.data.itens.map(item => item.idPalavraChave));

				$scope.hasNextPageKeywords = true;

				if (keywords[0] && keywords[0].totalPasta > 10)
					$scope.showMoreKeywords = true;
				else $scope.hasNextPageKeywords = false;

				$scope.keyWordsMovements.setItems(keywords);
				responseStore.setReady(true);
				responseStore.setNotLoading();

				$scope.returnPage = false;
			});
		};

		$scope.processPasteUrl = () => {
			let pasta = $scope.paramsPasta();
			let exist = $scope.publicationPaste.filter(p => p.id == pasta);
			let notExist = pasta && !exist.length ? true : false;
			let access = pasta ? (exist.length ? true : false) : true;

			const url = $scope.currentPageUrl();

			if (notExist && url != '/movimentacoes/lixeira')
				$rootScope.deleteAllOfCount();

			return access;
		};

		$scope.paramsPasta = () => {
			const url = new URLSearchParams(window.location.search);

			return url.get('pasta');
		};

		$rootScope.orderField = 'dataMovimentacao';

		$rootScope.order = '-';

		$rootScope.changeProcessOrder = setMovements => {
			$rootScope.recordProcessMovements($scope.processMovements, setMovements);
		};

		$rootScope.changeKeywordOrder = setMovements => {
			$rootScope.recordKeyWordsMovements(
				$scope.keyWordsMovements,
				null,
				setMovements
			);
		};

		/**
		 * Recupera processos.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.processMovements = helper.responseStore();
		 *
		 * // Recupera as aplicações.
		 * $scope.recordProcessMovements($scope.processMovements);
		 */
		$rootScope.recordProcessMovements = (responseStore, params) => {
			responseStore.setReady(false);

			$scope.currentPageProcess = 1;

			const url = $location.$$url;

			if (
				!url.includes('/movimentacoes/todas-conta') &&
				!url.includes('/movimentacoes/lixeira') &&
				((url.includes('processos') &&
					!permissions.has('createMovements') &&
					!permissions.has('createManualMovements')) ||
					(url.includes('/movimentacoes/publicacoes') &&
						!permissions.has('createKeyword') &&
						!permissions.has('recordPublications')))
			) {
				return $state.transitionTo('root.default.initial', {
					inherit: false,
					reload: true
				});
			}

			$http({
				...helper.http(API.briefcase, 'processes'),
				params: {
					campos: 'id, naoLidas, nomePasta',
					ordenacao: $rootScope.order + $rootScope.orderField,
					registrosPorPagina: responseStore.getItemsPerPage(),
					paginaAtual: responseStore.getCurrentPage(),
					IdGrupo:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				},
				noCancelOnRouteChange: true
			})
				.then(response => {
					$rootScope.submenuProcess(false, response, params);
				})
				.finally(() => {
					responseStore.setReady(true);

					responseStore.setNotLoading();
				});
		};

		$rootScope.submenuProcess = (iNit, response, params) => {
			if (params == 'setMovements') {
				$scope.paramsSubmenuProcess = true;
			} else {
				$scope.paramsSubmenuProcess = $scope.processMovements.hasNotItems();
			}

			if (iNit) {
				$scope.processMovements.setReady(false);
			} else if (!iNit && $scope.paramsSubmenuProcess) {
				$scope.processPaste = response.data.itens;

				let { itens, paginacao } = response.data;

				if (Array.isArray(itens)) {
					const seen = new Set();

					itens = itens.filter(item => {
						const key = String(item.id);

						if (seen.has(key)) return false;

						seen.add(key);

						return true;
					});
				}

				$scope.currentPageProcess =
					!$scope.currentPageProcess && paginacao.registrosPorPagina == 20
						? 2
						: !$scope.currentPageProcess
						? 1
						: $scope.currentPageProcess;

				$scope.existsProcess = true;

				$scope.processMovements.setItems(itens);

				if (paginacao && paginacao.paginaAtual < paginacao.paginaTotal)
					$scope.hasNextPageProcess = true;
				else $scope.hasNextPageProcess = false;

				let totalPages = paginacao.paginaTotal;

				$scope.showMoreProcess =
					totalPages > $scope.currentPageProcess ? true : false;

				$scope.markSelectedAccount();

				$scope.processMovements.setReady(true);

				$scope.processMovements.setNotLoading();
			}
		};

		$scope.currentPageUrlSearch = () => {
			let url = window.location.pathname;

			url = url + window.location.search;

			return url;
		};

		$rootScope.navegation = paste => {
			$scope.updateSelectedItemOnSubmenu(paste);
			sessionStorage.removeItem('__selected__');

			if (paste == 'keyword' || paste == 'all') {
				let params = {
					p: paste == 'keyword' ? '2' : '1'
				};

				$state.go(`root.default.movements.list${params.p}`, params, {
					inherit: false,
					reload: `root.default.movements.list${params.p}`
				});
			} else if (paste == 'trash') {
				if ($('#btn-trash').hasClass('trash_selected')) return;

				$rootScope.pageSelected = null;
				$rootScope.newPublicationChecked = [];
				$('#submenu-movements .todas').removeClass('selected');

				sessionStorage.setItem('__pageMovements__', 1);

				const url = $scope.currentPageUrlSearch();

				if (url.startsWith('/inss')) {
					if (url == '/inss') {
						sessionStorage.setItem('modulo', '/inss');
					} else {
						sessionStorage.setItem('modulo', url);
					}
				} else if (url !== '/processos') {
					$scope.verifyCurrentPageUrl();

					sessionStorage.setItem('modulo', $scope.environmentPageMov);
				} else {
					sessionStorage.setItem('modulo', 'pageProcessos');
				}

				$state.go('root.default.movements.list5', { inherit: false });
			} else if (paste == 'inss') {
				$rootScope.pageSelected = 'inss';
			} else {
				$rootScope.pageSelected = 'pageProcess';

				$state.go(
					'root.default.movements.processList',
					{},
					{
						inherit: false,
						reload: 'root.default.movements.processList'
					}
				);
			}
		};

		$scope.updateSelectedItemOnSubmenu = newItem => {
			switch (newItem) {
				case 'all':
					$rootScope.pageSelected = 'all';
					break;
				case 'keyword':
					$rootScope.pageSelected = 'keyword';
					break;
				case 'process':
					$rootScope.pageSelected = 'process';
					break;
				case 'inss':
					$rootScope.pageSelected = 'inss';
					break;
				case 'trash':
					$rootScope.pageSelected = 'trash';
					break;
				default:
					break;
			}
		};

		$scope.verifyCurrentPageUrl = () => {
			const url = $location.$$url.split('?')[0];

			switch (url) {
				case '/movimentacoes/publicacoes/pastas':
					$scope.environmentPageMov = 'publiPasta';
					break;
				case '/movimentacoes/publicacoes':
					$scope.environmentPageMov = 'publicacao';
					break;
				case '/movimentacoes/processos/pastas':
					$scope.environmentPageMov = 'processos';
					break;
				case '/movimentacoes/todas-conta':
					$scope.environmentPageMov = 'todas';
					break;
				default:
					break;
			}
		};

		$scope.checkExpansiveBrother = () => {
			let element = document.getElementById('processCollapse');
			let secondChild = element.children[1];

			if (!element || !secondChild) return;

			let value = secondChild.getAttribute('aria-expanded');

			return value == 'false' ? false : true;
		};

		$scope.verifyPasteCollapse = (id1, id2, boolean, event) => {
			$rootScope.periodsSubpoena = false;

			const url = $scope.currentPageUrl();
			const stringToCheck = id1 == 'keyword' ? 'publicacoes' : 'processos';
			const pastePubli =
				stringToCheck == 'publicacoes' &&
				url.includes(stringToCheck) &&
				url.includes('pasta');

			if (url.includes(stringToCheck) && !pastePubli) {
				$rootScope.toggleCollapse(id1, id2, null, event);

				return;
			}

			if (id1 == 'process') delete $state.params.lixeira;

			if (id1 === 'keyword' && $rootScope.pageSelected !== 'Key') {
				$scope.collapseClose = false;

				$rootScope.changeAllOfCountValue();
				$rootScope.cleanSelectedMov();

				$rootScope.navegation(id1);
			} else if (id1 === 'process' && url !== '/processos') {
				$scope.collapseClose = false;
				$rootScope.cleanSelectedMov();
				$rootScope.navegation(id1);
			} else if (id1 === 'keyword' && $rootScope.pageSelected == 'Key')
				$scope.collapseClose = true;
			else if (id1 === 'keyword' && $rootScope.pageSelected == 'processos')
				$scope.collapseClose = true;

			$rootScope.toggleCollapse(id1, id2, null, event);
			$('#submenu-movements .todas').removeClass('selected');

			$scope.collapseInfos(id1);
		};

		$scope.go = {
			process: (id1, id2, boolean, event) => {
				if ($rootScope.pageSelected !== 'pageProcess')
					$rootScope.navegation(id1);

				setTimeout(() => {
					$rootScope.toggleCollapse(id1, id2, null, event);
				}, 500);

				$('#submenu-movements .todas').removeClass('selected');
			}
		};

		$scope.checkScreenActive = screen => {
			const url = window.location.href; // Obtém a URL atual
			const stringToCheck = screen;

			if (url.includes(stringToCheck)) return true;

			return false;
		};

		$scope.checkPubliPaste = () => {
			const url = window.location.href; // Obtém a URL atual
			const stringToCheck = 'publicacoes';
			const pastePubli =
				stringToCheck == 'publicacoes' &&
				url.includes(stringToCheck) &&
				url.includes('pasta');

			return pastePubli;
		};

		$rootScope.toggleCollapse = (id1, id2, collap, event) => {
			if (!event || !event.target) return;

			const url = $scope.currentPageUrl();
			const stringToCheck = id1 == 'keyword' ? 'publicacoes' : 'processos';

			if (id1 === 'keyword') {
				setTimeout(() => {
					$rootScope.handleOnClickPub = true;
				}, 100);
			}

			if (id1 === 'process') {
				setTimeout(() => {
					$rootScope.handleOnClickProcess = true;
				}, 100);
			}

			let publicationPaste = document.querySelector('#toggle-publications');
			let processPaste = document.querySelector('#toggle-process');

			if (publicationPaste)
				var isPubli = publicationPaste.getAttribute('aria-expanded');

			if (processPaste) var isProc = processPaste.getAttribute('aria-expanded');

			const open =
				id1 == 'process' && processPaste && isProc === 'true'
					? true
					: id1 == 'keyword' && publicationPaste && isPubli === 'true'
					? true
					: false;

			if (open && !collap) return;

			if (!$rootScope.initProcess) $scope.getProcessOrKey(id1);

			const collapseElement1 = $('#' + id1),
				toggleCollapse1 = () => collapseElement1.collapse('toggle');

			const collapseElement2 = $('#' + id2),
				toggleCollapse2 = () => collapseElement2.collapse('toggle');

			if (id2 && collapseElement2.is('.show')) toggleCollapse2();

			if (id1) toggleCollapse1();

			if (!url.includes(stringToCheck))
				$('#publications').removeClass('selected');

			if (id2 == 'keyword') {
				const toogle = document.getElementById('toggle-publications');

				if (toogle) toogle.ariaExpanded = false;
			}

			$scope.collapseInfos(id1);
		};

		$scope.processInssButton = () => {
			$rootScope.params = [];

			$scope.navegation('inss');
			$('#submenu-movements .todas').removeClass('selected');

			$state.go('root.default.movements.inss', {
				inherit: false
			});
		};

		$scope.getProcessOrKey = id1 => {
			let perms = permissions.has(
				id1 === 'process' ? 'createMovements' : 'recordPublications'
			);
			let records =
				id1 === 'process'
					? $scope.processMovements.hasNotItems()
					: $scope.keyWordsMovements.hasNotItems();

			if (
				id1 === 'process' &&
				perms &&
				records &&
				$rootScope.handleOnClickProcess === false
			) {
				$rootScope.recordProcessMovements($scope.processMovements, 'process');
			} else if (
				id1 === 'keyword' &&
				perms &&
				records &&
				$rootScope.handleOnClickPub === false
			) {
				$rootScope.recordKeyWordsMovements(
					$scope.keyWordsMovements,
					null,
					'setMovements'
				);
			}
		};

		$scope.collapseInfos = id => {
			let collapse = [];

			if (id == 'keyword')
				collapse = ['toggle-publications', 'publications', 'processos'];
			else collapse = ['toggle-process', 'processos', 'publications'];

			$scope.verifyCollapseOpen(collapse, id);
		};

		$scope.verifyCollapseOpen = (ids, id1) => {
			// setTimeout(() => {
			let IDs = document.querySelector(`#${ids[0]}`);
			let id = document.getElementById(ids[1]);
			let id2 = document.getElementById(ids[2]);
			let hasItem = IDs
				? JSON.parse(IDs.getAttribute('aria-expanded'))
				: undefined;

			const url = $scope.currentPageUrl();
			const stringToCheck = id1 == 'keyword' ? 'publicacoes' : 'processos';

			if (hasItem) id.classList.add('selected');
			else {
				if (url.includes(stringToCheck)) return;

				id.classList.remove('selected');
			}

			id2.classList.remove('selected');
			// }, 100);
		};

		$rootScope.recordFolderToSubmenu = folder => {
			const hasOnList =
				folder.idTipoPasta === -2
					? $scope.keyWordsMovements
							.getItems()
							.some(keyword => keyword.id == folder.id)
					: $scope.processMovements
							.getItems()
							.some(process => process.id === folder.id);

			const existItems = true ? $scope.existsKeywords : $scope.existsProcess;

			if (!hasOnList && existItems) {
				const endpoint = folder.idTipoPasta === -2 ? 'GET' : 'processes';

				const params = {
					campos: '*',
					registrosPorPagina: 1,
					paginaAtual: 1,
					idTipoPasta: folder.idTipoPasta,
					ativo: true
				};

				if (folder.idTipoPasta === -2) params.ids = folder.id;
				else params.idProcesso = folder.idProcesso;

				$http({
					...helper.http(API.briefcase, endpoint),
					params: params
				}).then(res => {
					const selectedFolder = res.data.itens[0];

					$scope.keyWordsMovements.items = $scope.keyWordsMovements
						.getItems()
						.filter(item => item.id !== selectedFolder.id);

					if (folder.idTipoPasta === -2) {
						$scope.keyWordsMovements.pushItems([selectedFolder]);

						$scope.publicationPaste = $scope.keyWordsMovements.items;

						//Tiraram a necessidade
						// if (!$scope.collapseShow) $scope.verifyCollapseShow();
					} else {
						const hasProcess = $scope.processMovements.items.filter(
							item => item.id === selectedFolder.id
						);

						if (hasProcess.length == 0) {
							$scope.processMovements.pushItems([selectedFolder]);

							$scope.processPaste = $scope.processMovements.items;

							//Tiraram a necessidade
							if (!$scope.collapseShow) $scope.verifyCollapseShow();
						}
					}
				});
			}
		};

		$scope.functionClickDivers = () => {
			sessionStorage.removeItem('__selected__');

			if ($rootScope.printingProc == 'standard') {
				$rootScope.printingProc = 'click';
			} else if ($rootScope.printingProc == 'click') {
				$rootScope.printingProc = 'block';
			}
		};

		//metodo para selecionar
		$scope.setStorage = (item, value) => {
			sessionStorage.setItem(item, value);
		};

		$scope.allOfAccount = sessionStorage.getItem('__allOfAccount__');

		//muda vizualização pra publicações gerais
		$rootScope.changeAllOfCountValue = () => {
			//variavel que indica se o filtro de periodos tava selecionado
			if ($rootScope.periodsFolderTypeSelected === true)
				$rootScope.periodsFolderTypeSelected = false;

			//Seta no SessionStorage infos que indicam que vc esta no ambiente de publicações
			['__allOfAccount__', '__processPaste__', '__publicationPaste__'].forEach(
				(item, index) => {
					index == 0
						? $scope.setStorage(item, true)
						: $scope.setStorage(item, false);
				}
			);

			const url = $scope.currentPageUrl();

			//metodo que limpa infos do  localStorage dos filtros
			$rootScope.deleteItemLocal();
			//remove class selected de todos da conta
			$scope.markSelectedAccount();
			//passa null para o modulo pasta indicando que saio do ambiente de pasta
			if (url != '/movimentacoes/lixeira') $scope.setStoragePasta(null, false);

			sessionStorage.removeItem('__pageMovements__');

			if (
				url.includes('/movimentacoes/publicacoes/detalhes') ||
				url.includes('/movimentacoes/publicacoes/detalhar')
			) {
				$scope.setStoragePasta(null, false);
				$rootScope.pageSelected = 'detalhes';

				return;
			}

			$rootScope.pageSelected = 'Key';
		};

		$rootScope.cloneAllPubli = () => {
			//Seta no SessionStorage infos que indicam que vc esta no ambiente de publicações
			['__allOfAccount__', '__processPaste__', '__publicationPaste__'].forEach(
				(item, index) => {
					index == 0
						? $scope.setStorage(item, true)
						: $scope.setStorage(item, false);
				}
			);

			const url = $scope.currentPageUrl();

			//remove class selected de todos da conta
			$scope.markSelectedAccount();
			//passa null para o modulo pasta indicando que saio do ambiente de pasta
			if (url != '/movimentacoes/lixeira') $scope.setStoragePasta(null, false);

			if (
				url.includes('/movimentacoes/publicacoes/detalhes') ||
				url.includes('/movimentacoes/publicacoes/detalhar')
			) {
				$scope.setStoragePasta(null, false);
				$rootScope.pageSelected = 'detalhes';

				return;
			}

			$rootScope.pageSelected = 'Key';
		};

		$scope.clearModuleFilters = () => {
			[
				'_MODULE_PEOPLE_FILTERS_',
				'_MODULE_FINANCIAL_FILTERS_',
				'_MODULE_MOVEMENTS_FILTERS_',
				'_MODULE_INTIMATION_FILTERS_',
				'_MODULE_SCHEDULE_FILTERS_'
			].forEach(sessionStorage.removeItem.bind(sessionStorage));
		};

		//muda vizualização para todas da conta
		$rootScope.deleteAllOfCountValue = (paste, navigate = true) => {
			$rootScope.disableDoubleclick = false;
			//variavel que indica se o filtro de periodos tava selecionado
			if ($rootScope.periodsFolderTypeSelected === true)
				$rootScope.periodsFolderTypeSelected = false;

			//Seta no SessionStorage infos que indicam que vc esta no ambiente de todas da conta
			['__allOfAccount__', '__publicationPaste__', '__processPaste__'].forEach(
				item => {
					$scope.setStorage(item, false);
				}
			);

			$scope.clearModuleFilters();

			const url = $scope.currentPageUrl();

			paste && navigate && $rootScope.navegation(paste);

			//metodo que limpa infos do session dos filtros
			$scope.deleteItemSession();
			//metodo que limpa infos do  localStorage dos filtros
			$rootScope.deleteItemLocal();
			//add class selected em todas da conta
			$scope.markSelectedAccount();
			//limpa registros selecionados na listagem
			$rootScope.cleanSelectedMov();
			//passa null para o modulo pasta indicando que saio do ambiente de pasta
			if (url != '/movimentacoes/lixeira') $scope.setStoragePasta(null, false);

			sessionStorage.removeItem('__pageMovements__');

			$rootScope.pageSelected = 'todas';
		};

		$scope.deleteItemSession = () => sessionStorage.removeItem('__selected__');

		$rootScope.cloneAll = () => {
			//Seta no SessionStorage infos que indicam que vc esta no ambiente de todas da conta
			['__allOfAccount__', '__publicationPaste__', '__processPaste__'].forEach(
				item => {
					$scope.setStorage(item, false);
				}
			);
			const url = $scope.currentPageUrl();

			//add class selected em todas da conta
			$scope.markSelectedAccount();
			//limpa registros selecionados na listagem
			$rootScope.cleanSelectedMov();
			//passa null para o modulo pasta indicando que saio do ambiente de pasta
			if (url != '/movimentacoes/lixeira') $scope.setStoragePasta(null, false);

			if (
				url.includes('/movimentacoes/todas-conta/detalhes') ||
				url.includes('/movimentacoes/todas-conta/detalhar')
			) {
				$scope.setStoragePasta(null, false);
				$rootScope.pageSelected = 'detalhes';

				return;
			}

			$rootScope.pageSelected = 'todas';
		};

		//muda vizualização para pastas processos
		$rootScope.deleteAllOfCount = id => {
			$rootScope.disableDoubleclick = true;

			const paramsPasta = $scope.paramsPasta();
			let ids = id ? id : '';

			if (ids === '') {
				try {
					ids = JSON.parse(paramsPasta);
				} catch (error) {
					ids = '';
				}
			}

			if (ids && ids.length > 0 && /\D/.test(ids)) {
				ids = '';
			}

			var params = {
				pasta: ids,
				p: '4'
			};

			//validação para não ocorrer duplo click
			if ($rootScope.printingProc == 'click')
				$state.transitionTo(`root.default.movements.list${params.p}`, params, {
					inherit: false,
					reload: `root.default.movements.list${params.p}`
				});

			const url = $scope.currentPageUrl();

			if (
				url.includes('/movimentacoes/processos/pastas/detalhes') ||
				url.includes('/movimentacoes/processos/pastas/detalhar')
			) {
				$rootScope.pageSelected = 'detalhes';

				return;
			}

			//variavel que indica se o filtro de periodos tava selecionado
			if ($rootScope.periodsFolderTypeSelected === true)
				$rootScope.periodsFolderTypeSelected = false;

			//Seta no SessionStorage infos que indicam que vc esta no ambiente de pasta processos
			['__processPaste__', '__allOfAccount__', '__publicationPaste__'].forEach(
				(item, index) => {
					index == 2
						? $scope.setStorage(item, false)
						: $scope.setStorage(item, true);
				}
			);

			//metodo que limpa infos do  localStorage dos filtros
			$rootScope.deleteItemLocal();
			//remove class selected de todos da conta
			$scope.markSelectedAccount();
			//limpa registros selecionados na listagem
			$rootScope.cleanSelectedMov();
			//passa id para o modulo pasta indicando que esta no ambiente de pasta
			if (url != '/movimentacoes/lixeira') $scope.setStoragePasta(ids, true);

			sessionStorage.removeItem('__pageMovements__');
			$timeout(() => {
				$rootScope.printingProc = 'standard';
			}, 3000);

			$rootScope.pageSelected = 'processos';

			$rootScope.showChatWidget = false;
			$scope.__allOfAccount__ = JSON.parse(
				sessionStorage.getItem('__allOfAccount__')
			);

			$timeout(() => {
				$rootScope.disableDoubleclick = JSON.parse(
					sessionStorage.getItem('__allOfAccount__')
				);
			}, 10);
		};

		$rootScope.clonePasteProc = id => {
			const paramsPasta = $scope.paramsPasta();
			let ids = id ? id : '';

			if (ids === '') {
				try {
					ids = JSON.parse(paramsPasta);
				} catch (error) {
					ids = '';
				}
			}

			if (ids && ids.length > 0 && /\D/.test(ids)) {
				ids = '';
			}

			//Seta no SessionStorage infos que indicam que vc esta no ambiente de pasta processos
			['__processPaste__', '__allOfAccount__', '__publicationPaste__'].forEach(
				(item, index) => {
					index == 2
						? $scope.setStorage(item, false)
						: $scope.setStorage(item, true);
				}
			);

			const url = $scope.currentPageUrl();

			if (
				url.includes('/movimentacoes/processos/pastas/detalhes') ||
				url.includes('/movimentacoes/processos/pastas/detalhar')
			) {
				$rootScope.pageSelected = 'detalhes';

				return;
			}

			//remove class selected de todos da conta
			$scope.markSelectedAccount();
			//limpa registros selecionados na listagem
			$rootScope.cleanSelectedMov();
			//passa id para o modulo pasta indicando que esta no ambiente de pasta

			if (url != '/movimentacoes/lixeira' && ids.length > 0)
				$scope.setStoragePasta(ids, true);

			$timeout(() => {
				$rootScope.printingProc = 'standard';
			}, 3000);

			$rootScope.pageSelected = 'processos';
		};

		//muda vizualização para pastas publicações
		$rootScope.publicationAccount = id => {
			sessionStorage.setItem('__allOfAccount__', true);
			sessionStorage.removeItem('__selected__');

			const paramsPasta = $scope.paramsPasta();
			let ids = id ? id : '';

			if (ids === '') {
				try {
					ids = JSON.parse(paramsPasta);
				} catch (error) {
					ids = '';
				}
			}

			//seleciona periodos de os ultimos 15 dias
			$rootScope.datePeriods($stateParams, ids);

			//Seta no SessionStorage infos que indicam que vc esta no ambiente de pasta publicações
			['__processPaste__', '__publicationPaste__', '__allOfAccount__'].forEach(
				(item, index) => {
					index == 0
						? $scope.setStorage(item, false)
						: $scope.setStorage(item, true);
				}
			);

			//limpa registros selecionados na listagem
			$rootScope.cleanSelectedMov();
			//metodo que limpa infos do  localStorage dos filtros
			$rootScope.deleteItemLocal();
			//remove class selected de todos da conta
			$scope.markSelectedAccount();
			//passa id para o modulo pasta indicando que esta no ambiente de pasta
			$scope.setStoragePasta(ids, true);

			sessionStorage.removeItem('__pageMovements__');
			$rootScope.pageSelected = 'pastaPubli';
			$timeout(() => {
				$rootScope.disableDoubleclick = JSON.parse(
					sessionStorage.getItem('__allOfAccount__')
				);
			}, 10);
		};

		$rootScope.clonePastePubli = id => {
			const paramsPasta = $scope.paramsPasta();
			let ids = id ? id : '';

			if (ids === '') {
				try {
					ids = JSON.parse(paramsPasta);
				} catch (error) {
					ids = '';
				}
			}

			['__processPaste__', '__publicationPaste__', '__allOfAccount__'].forEach(
				(item, index) => {
					index == 0
						? $scope.setStorage(item, false)
						: $scope.setStorage(item, true);
				}
			);

			const url = $scope.currentPageUrl();

			//remove class selected de todos da conta
			$scope.markSelectedAccount();
			//passa id para o modulo pasta indicando que esta no ambiente de pasta
			if (url != '/movimentacoes/lixeira') $scope.setStoragePasta(ids, true);

			$rootScope.pageSelected = 'pastaPubli';
		};

		//set info de pasta selecionada no sessionStorage
		$scope.setStoragePasta = (id, set) => {
			if (set) sessionStorage.setItem('modulo-pasta', id);
			else sessionStorage.removeItem('modulo-pasta');
		};

		let totalMovNotReadRequestId = 0;

		$rootScope.totalMovNotReadLoading = true;

		$rootScope.getTotalNotRead = () => {
			const requestId = ++totalMovNotReadRequestId;

			$rootScope.totalMovNotReadLoading = true;

			let grupoUser = localStorage.getItem('__idGroupUserData__');

			if (!grupoUser) {
				var params = null;
			} else {
				let idGrupoUser = parseInt(grupoUser);
				var params = idGrupoUser;
			}

			$http({
				...helper.http(API.movementsClientsNotRead, 'GET'),
				params: {
					...helper.httpFields(['*']),
					idGrupoUsuarios: params
				},
				noCancelOnRouteChange: true
			})
				.then(response => {
					const itens = response.data.itens || [];
					const totalNaoLidas = itens[0] ? itens[0].totalNaoLidas : 0;

					if (requestId !== totalMovNotReadRequestId) return;

					$rootScope.totalMovNotRead = totalNaoLidas || 0;
				})
				.catch(() => {
					if (requestId !== totalMovNotReadRequestId) return;

					$rootScope.totalMovNotRead = $rootScope.totalMovNotRead || 0;
				})
				.finally(() => {
					if (requestId !== totalMovNotReadRequestId) return;

					$rootScope.totalMovNotReadLoading = false;
				});
		};

		$rootScope.getTotalNotRead();

		//verifica se todos da conta esta selecionada pra inserir e remover, class selected
		$scope.markSelectedAccount = () => {
			setTimeout(() => {
				const allCont = sessionStorage.getItem('__allOfAccount__');

				if (
					allCont === 'false' &&
					!$stateParams.lixeira &&
					$scope.checkScreenActive('todas-conta')
				)
					$('#account').toggleClass('selected');
				else if (allCont === 'true') $('#account').removeClass('selected');
			}, 200);
		};

		$rootScope.$on('someEvent', (e, args) => {
			if (
				args &&
				args.idTipoPasta == -3 &&
				!itemExist($scope.processMovements.items, args.id)
			) {
				$scope.processMovements.items.unshift(args);
			} else if (
				args &&
				args.idTipoPasta == -2 &&
				!itemExist($scope.keyWordsMovements.items, args.id)
			) {
				args.situacaoPalavraChave = true;
				$scope.keyWordsMovements.items.unshift(args);
			}
		});

		$rootScope.$on('processRenamed', (event, args) => {
			if (!args || !args.id || !$scope.processMovements) return;

			const normalizeId = val => Number(val);
			const id = normalizeId(args.id);
			const nome = args.nome || '';
			const originalIndex =
				typeof args.index === 'number' && args.index >= 0 ? args.index : null;

			if (typeof $scope.processMovements.updateItem === 'function') {
				$scope.processMovements.updateItem(
					{
						nome,
						nomePasta: nome,
						pastaUsuarioCliente: nome
					},
					'id',
					args.id
				);
			}

			if (
				$scope.processMovements &&
				Array.isArray($scope.processMovements.items)
			) {
				const seen = new Set();

				$scope.processMovements.items = $scope.processMovements.items.reduce(
					(acc, proc) => {
						const key = normalizeId(proc.id);

						const updated =
							key === id
								? { ...proc, nome, nomePasta: nome, pastaUsuarioCliente: nome }
								: proc;

						if (seen.has(key)) return acc;
						seen.add(key);
						acc.push(updated);

						return acc;
					},
					[]
				);

				if (
					originalIndex !== null &&
					originalIndex >= 0 &&
					originalIndex < $scope.processMovements.items.length
				) {
					const currentIdx = $scope.processMovements.items.findIndex(
						proc => normalizeId(proc.id) === id
					);

					if (currentIdx > -1 && currentIdx !== originalIndex) {
						const [moved] = $scope.processMovements.items.splice(currentIdx, 1);

						$scope.processMovements.items.splice(originalIndex, 0, moved);
					}
				}
			}

			$scope.$applyAsync();
		});

		// $scope.cadastrarProcesso = () => (window.location = '/cadastrar-processos');

		// $scope.addAutomaticProcesses = () =>
		// 	(window.location = '/cadastrar-processos-automaticos');

		$('#modalCreateAgendaEvent').on('hide', () => {
			$rootScope.formCreatePrazo.taskToEdit.processo = {};

			return $scope.$resetFormValidation('createEvent')();
		});

		$scope.keywordFilters = {
			keyword: '',
			firstRequest: true
		};

		$scope.openCreateAgendaEventModal = () => {
			$('#modalStartTemplate').modal('hide');

			$timeout(() => {
				$('#modalCreateAgendaEvent').modal('show');
			}, 500);
		};

		$rootScope.openVideoModal = video => {
			$scope.videoType = video;

			$('#modalVideo').modal('show');

			function returnUrlVideo() {
				switch (video) {
					case 'keys':
						return 'https://www.youtube.com/embed/K_aQr4NlMbg';
					case 'process':
						return 'https://www.youtube.com/embed/07C2dsL6DcY';
					case 'processInss':
						return 'https://www.youtube.com/embed/H0MUxUU6KUE';
					default:
						return '';
				}
			}

			$('.iframeParent').html(`
				<iframe width="100%" height="348" class="iframe"
					src="${returnUrlVideo()}"
					frameborder="0">
				</iframe>
			`);
		};

		//PAGINAÇÃO P/ MODAIS
		$scope.recordKeywordsMovementsPaginate = (
			paginaAtual,
			list,
			returnPage
		) => {
			$scope.showMoreOrLessKey = true;

			$scope.currentPageKeywords = returnPage ? paginaAtual + 1 : 1;

			if (!returnPage) {
				$scope.returnPage = true;

				$rootScope.recordKeyWordsMovements($scope.keyWordsMovements);

				$timeout(() => {
					$scope.showMoreOrLessKey = false;
				}, 1000);

				return;
			}

			$http({
				...helper.http(API.briefcase, 'GET'),
				params: {
					campos: '*',
					registrosPorPagina: 10,
					paginaAtual: $scope.currentPageKeywords,
					idTipoPasta: '-2',
					ativo: true,
					idGrupoUsuarios:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			}).then(response => {
				let listPage = [];

				// if ($stateParams.pasta) listPage = response.data.itens.filter(item => item.id != $state.params.pasta);

				listPage = response.data.itens.filter(
					item => item.id != $state.params.pasta
				);

				list.pushItems(listPage);

				let totalPages = 0;

				if (response.data.itens[0])
					totalPages = Math.ceil(response.data.itens[0].totalPasta / 10);

				$scope.showMoreKeywords = totalPages > $scope.currentPageKeywords;

				$scope.showMoreOrLessKey = false;
			});
		};

		$scope.recordProcessMovementsPaginate = (paginaAtual, list, returnPage) => {
			$scope.showMoreOrLessProc = true;

			$scope.currentPageProcess = paginaAtual + 1;

			if (!returnPage) {
				$scope.currentPageProcess = 1;
			}

			$http({
				...helper.http(API.briefcase, 'processes'),
				params: {
					campos: 'id, naoLidas, nomePasta',
					registrosPorPagina: 10,
					paginaAtual: $scope.currentPageProcess,
					ordenacao: $rootScope.order + $rootScope.orderField,
					IdGrupo:
						$scope.groupUserSelected && $scope.groupData
							? $scope.groupData.idGrupo
							: null
				}
			}).then(response => {
				let listPage = [];

				response.data.itens.map(item => {
					if (item.id != $stateParams.pasta) listPage.push(item);
				});

				if (!returnPage && $scope.currentPageProcess == 1)
					list.items = response.data.itens;
				else list.pushItems(listPage);

				let paginacao = response.data.paginacao;

				let totalPages = paginacao.paginaTotal;

				// if (response.data.itens[0]) totalPages = Math.ceil(response.data.itens[0].totalPasta / 10);

				$scope.showMoreProcess =
					totalPages > $scope.currentPageProcess ? true : false;

				$scope.showMoreOrLessProc = false;
			});
		};

		$rootScope.recordValuesProKey = () => {
			let publicationPermission = permissions.has('recordPublications');
			let movementPermission = permissions.has('createMovements');
			let proc = JSON.parse(sessionStorage.getItem('__processPaste__'));
			let publi = JSON.parse(sessionStorage.getItem('__publicationPaste__'));
			let allOf = JSON.parse(sessionStorage.getItem('__allOfAccount__'));

			if (publicationPermission && (publi || (allOf && !proc) || !allOf))
				$rootScope.recordKeyWordsMovements(
					$scope.keyWordsMovements,
					null,
					'setMovements'
				);

			if (movementPermission && (proc || !allOf))
				movementPermission &&
					$rootScope.recordProcessMovements(
						$scope.processMovements,
						'setMovements'
					);
		};

		$rootScope.updateValues = () => {
			permissions.loadPermissions().then(async () => {
				const publicationPermission = permissions.has('recordPublications');

				const movementPermission = permissions.has('createMovements');

				$scope.hasPublications = publicationPermission;

				$scope.hasProcess = movementPermission;

				if (
					!idProdutoAdvise ||
					(idProdutoAdvise != -1 &&
						idProdutoAdvise != -2 &&
						idProdutoAdvise != -3)
				)
					return false;

				if (!movementPermission && !publicationPermission) {
					$scope.showVideo = true;
					$rootScope.keyWordsMovementsVideo = true;
					$rootScope.processMovementsVideo = true;

					return false;
				} else {
					$scope.showVideo = false;
				}

				if (publicationPermission) {
					const allOfAccount = sessionStorage.getItem('__allOfAccount__');

					if (allOfAccount !== 'false')
						sessionStorage.setItem('__allOfAccount__', true);

					const urlParams = new URLSearchParams(window.location.search);
					const existPaste = urlParams.get('pasta');

					if (!existPaste) {
						sessionStorage.setItem('__processPaste__', false);
						sessionStorage.setItem('__publicationPaste__', false);
					}
				} else {
					$rootScope.keyWordsMovementsVideo = true;
					sessionStorage.setItem('__allOfAccount__', false);
				}

				if (!movementPermission) {
					$rootScope.processMovementsVideo = true;
				}
			});
		};

		$scope.currentPageUrl = () => {
			return $location.$$url.split('?')[0];
		};

		$scope.verifyCollapseShow = setMovements => {
			const url = $location.$$url.split('?')[1];
			var pasta = [];
			// let andamentos = [];
			var publicacao = [];

			if (url && url.indexOf('pasta') >= 0) {
				pasta = url.split('&')[0];
				pasta = pasta.split('=')[1];
			}

			setTimeout(() => {
				if (!!$scope.publicationPaste)
					publicacao = $scope.publicationPaste.filter(item => item.id == pasta);

				if (pasta && !publicacao.length && url && url.indexOf('pasta') >= 0) {
					$rootScope.recordProcessMovements(
						$scope.processMovements,
						setMovements
					);
					$rootScope.printingProc == 'standard';
					$rootScope.deleteAllOfCount(pasta);
					// $rootScope.toggleCollapse('process', 'keyword');
				}

				if (!!$scope.processPaste) {
					// andamentos = $scope.processPaste.filter(item => item.id == pasta);
					$rootScope.printingProc == 'standard';
					$rootScope.deleteAllOfCount(pasta);
				}

				// if (publicacao.length > 0) {
				// 	$rootScope.toggleCollapse('keyword', 'process');
				// } else if (andamentos.length > 0 && !setMovements) {
				// 	$rootScope.toggleCollapse('process', 'keyword');
				// }
			}, 5);
		};

		$rootScope.updateValues();

		(function() {
			if (!!$rootScope.cleanSelectedMov) {
				$rootScope.cleanSelectedMov();
			}
		})();

		$rootScope.cleanSelectedMov = () => {
			if (!!$rootScope.newPublicationChecked) {
				$rootScope.newPublicationChecked = [];
			} else if (!!$rootScope.newPublicationChecked) {
				$rootScope.aux = [];
				$rootScope.aux = $rootScope.newPublicationChecked;
				$rootScope.newPublicationChecked = $rootScope.aux;
			}
		};

		$scope.cadastrarProcesso = () => (window.location = '/cadastrar-processos');

		$scope.addAutomaticProcesses = () =>
			(window.location = '/cadastrar-processos-automaticos');
	}
]);

export default controller;
